import styled, { css } from "styled-components";
import { device } from "../../device.js";

import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Modal from "@material-ui/core/Modal";
import IconButton from "@material-ui/core/IconButton";
import Lottie from "react-lottie-player";

import Carousel from "@brainhubeu/react-carousel";
import "@brainhubeu/react-carousel/lib/style.css";

export const StyledWrapper = css`
    width: 100%;
    height: calc(${(props) => `${props.vh}px`} * 100);
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Old versions of Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
`;

export const ModelWrapper = styled.div`
    width: 100%;
    height: 75%;
    background-color: #ffdbb4;

    @media ${device.mobileM} {
        height: 80%;
    }
    @media ${device.iPhone6} {
        height: 75%;
    }
    @media ${device.iPhoneX} {
        height: 80%;
    }
    @media ${device.iPhone11} {
        height: 80%;
    }
    @media ${device.iPhone6Plus} {
        height: 75%;
    }
    @media ${device.mobileL} {
        height: 80%;
    }
`;

export const SliderWrapper = styled.div`
    height: 25%;
    background-color: #ffefda;

    @media ${device.mobileM} {
        height: 20%;
    }
    @media ${device.iPhone6} {
        height: 25%;
    }
    @media ${device.iPhoneX} {
        height: 20%;
    }
    @media ${device.iPhone11} {
        height: 20%;
    }
    @media ${device.iPhone6Plus} {
        height: 25%;
    }
    @media ${device.mobileL} {
        height: 20%;
    }
`;

export const StyledTypography = styled(Typography)`
    padding-top: 3%;
    padding-bottom: 2%;
    @media ${device.mobileXS} {
        padding-top: 2%;
        padding-bottom: 0;
        font-size: 0.7rem;
    }
    @media ${device.mobileS} {
        font-size: 0.9rem;
    }
    @media ${device.mobileM} {
        font-size: 1rem;
    }
    @media ${device.mobileL} {
        padding-top: 1%;
        font-size: 1.5rem;
    }
`;

export const StyledAnnotationWrapper = css`
    background-image: url(${(props) => props.annotationBg});
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    width: 95%;
    height: auto;
    text-align: center;
    box-sizing: border-box;

    @media ${device.mobileXS} {
        padding: 10%;
    }
    @media ${device.mobileS} {
        padding: 8%;
    }
    @media ${device.mobileM} {
        padding: 8%;
    }
    @media ${device.mobileL} {
        padding: 8%;
    }
`;

export const StyledAnnotation = styled.p`
    margin: 0;
    white-space: pre;
    @media ${device.mobileXS} {
        font-size: 0.7rem;
    }
    @media ${device.mobileS} {
        font-size: 0.9rem;
    }
    @media ${device.mobileM} {
        font-size: 1rem;
    }
    @media ${device.mobileL} {
        font-size: 1.5rem;
    }
`;

export const StyledLink = css`
    color: ${(props) => props.linkColorState};
    text-decoration: none;
    @media ${device.mobileXS} {
        font-size: 0.7rem;
    }
    @media ${device.mobileS} {
        font-size: 0.9rem;
    }
    @media ${device.mobileM} {
        font-size: 1rem;
    }
    @media ${device.mobileL} {
        font-size: 1.5rem;
    }
`;

export const StyledARIcon = styled.img`
    width: 12%;
    padding: 2%;
`;

export const StyledARButton = css`
    font-family: "Nunito", sans-serif;
    font-weight: 700;
    display: ${(props) => props.arButtonState};
    align-items: center;
    justify-content: center;
    background-color: white;
    border-radius: 50px;
    border: none;
    position: absolute;
    bottom: 2vh;
    left: 27vw;
    width: 50%;
    text-align: center;
    outline: none;
    text-transform: none;
    padding: 0 3px;

    &:hover {
        color: #000;
        background-color: #fff;
    }

    @media ${device.mobileL} {
        left: 32vw;
        width: 35%;
    }
`;

export const StyledCarousel = styled(Carousel)`
    width: 100%;
    height: 85%;
    box-sizing: border-box;

    img {
        width: 80%;
        height: auto;
        object-fit: contain;
    }
    @media ${device.mobileXS} {
        img {
            width: 75%;
            height: auto;
        }
    }
    @media ${device.mobileS} {
        margin-top: 3%;
        img {
            width: 85%;
            height: auto;
        }
    }
    @media ${device.mobileM} {
        margin-top: 1%;
        img {
            width: 80%;
            height: auto;
        }
    }
    @media ${device.mobileL} {
        margin-top: 0;
        img {
            width: 75%;
            height: auto;
        }
    }
`;

export const StyledModal = styled(Modal)`
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const StyledModalTitle = styled.h2`
    margin-top: 2%;
    margin-bottom: 2%;
    @media ${device.mobileXS} {
        font-size: 1em;
    }
    @media ${device.mobileS} {
        font-size: 1.3em;
    }
    @media ${device.iPhone5} {
        font-size: 1.1em;
    }
    @media ${device.mobileM} {
        font-size: 1.5em;
    }
    @media ${device.iPhone6} {
        font-size: 1.3em;
    }
    @media ${device.iPhone6Plus} {
        font-size: 1.3em;
    }
    @media ${device.mobileL} {
        font-size: 1.8em;
    }
`;

export const StyledModalDescription = styled.p`
    margin-top: 2%;
    margin-bottom: 2%;
    padding: 2% 5%;
    @media ${device.mobileXS} {
        font-size: 0.8em;
    }
    @media ${device.mobileS} {
        font-size: 0.9em;
    }
    @media ${device.iPhone5} {
        font-size: 0.8em;
    }
    @media ${device.mobileM} {
        font-size: 1em;
    }
    @media ${device.iPhone6} {
        font-size: 0.9em;
    }
    @media ${device.iPhone6Plus} {
        font-size: 0.9em;
    }
    @media ${device.mobileL} {
        font-size: 1.2em;
    }
`;

export const StyledPaper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background-color: bisque;
    border-radius: 15px;
    padding: 8px 5px 24px;
    box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2),
        0px 5px 8px 0px rgba(0, 0, 0, 0.14),
        0px 1px 14px 0px rgba(0, 0, 0, 0.12);
    text-align: center;
    outline: none;

    @media ${device.mobileXS} {
        width: 65%;
    }
    @media ${device.mobileS} {
        width: 70%;
    }
    @media ${device.iPhone5} {
        width: 65%;
    }
    @media ${device.mobileM} {
        width: 75%;
    }
    @media ${device.iPhone6} {
        width: 70%;
    }
    @media ${device.iPhone6Plus} {
        width: 70%;
    }
    @media ${device.mobileL} {
        width: 80%;
    }
`;

export const StyledErrorPaper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background-color: bisque;
    border-radius: 15px;
    padding: 8px 5px 24px;
    box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2),
        0px 5px 8px 0px rgba(0, 0, 0, 0.14),
        0px 1px 14px 0px rgba(0, 0, 0, 0.12);
    text-align: center;
    outline: none;

    @media ${device.mobileXS} {
        width: 75%;
    }
    @media ${device.mobileS} {
        width: 80%;
    }
    @media ${device.iPhone5} {
        width: 75%;
    }
    @media ${device.mobileM} {
        width: 75%;
    }
    @media ${device.iPhone6} {
        width: 80%;
    }
    @media ${device.iPhone6Plus} {
        width: 80%;
    }
    @media ${device.mobileL} {
        width: 85%;
    }
`;

export const DownloadButton = styled(Button)`
    font-weight: 700;
    color: #fff;
    background-color: black;
    border-radius: 50px;

    &:hover {
        color: #000;
        background-color: #fff;
    }
    @media ${device.mobileXS} {
        width: 85%;
    }
    @media ${device.mobileS} {
        width: 65%;
    }
    @media ${device.mobileM} {
        width: 65%;
    }
    @media ${device.mobileL} {
        width: 45%;
    }
`;

export const CancelButton = styled(IconButton)`
    align-self: flex-end;
    color: #000;
    padding: 0;

    &:hover {
        color: #fff;
    }
`;

export const StyledLottie = styled(Lottie)`
    height: auto;
    width: 80%;
    margin: auto;

    @media ${device.mobileXS} {
        width: 65%;
    }
    @media ${device.mobileS} {
        width: 70%;
    }
    @media ${device.iPhone5} {
        width: 65%;
    }
    @media ${device.mobileM} {
        width: 70%;
    }
    @media ${device.mobileL} {
        width: 65%;
    }
`;

export const StyledErrorLottie = styled(Lottie)`
    height: auto;
    width: 100%;
    margin-bottom: 15%;
`;
